export const navItems = [
  {
    text: 'Principal',
    i18n: 'menu.main',
    group: true,
    hideInBreadcrumb: true,
    children: [
      {
        text: 'Home',
        link: '/',
        icon: 'anticonanticon-home',
      },
      {
        text: 'Meus Dados',
        link: '/autonomous',
        icon: 'anticonanticon-user'
      },
      {
        text: 'Meus Recibos',
        link: '/receipts/list',
        icon: 'anticonanticon-file-text'
      },
      {
        text: 'Meus Contratos',
        link: '/contracts/list',
        icon: 'anticonanticon-form'
      },
      {
        text: 'Meus Informes',
        link: '/informes/list',
        icon: 'anticonanticon-diff'
      }
    ],
  },
];
